export default { sha: 'cf510571cbc3944f8e4a19892132cd30ce2e4e87', buildNumber: 'undefined' }
